import React from 'react';
import UserBtn from './Buttons/UserBtn';
import TrialAccount from './TrialAccount';
import SearchBtn from './Buttons/SearchBtn';
import DarkModeBtn from './Buttons/DarkModeBtn';
import TranslateBtn from './Buttons/TranslateBtn';
import ShortcutsBtn from './Buttons/ShortcutsBtn';
import NavMenuMobile from './Buttons/NavMenuMobile';
import NotificationBtn from './Buttons/NotificationBtn';
import useScreenWidth from '../../store/useScreenWidth';
import { useDarkModeStore } from '../../store/useDarkModeStore';

const TopBar = () => {
    const { darkMode } = useDarkModeStore();
    const isSmallScreen = useScreenWidth();

    return (
        <div
            className="sidebar-top"
            style={darkMode ? { background: 'var(--dark-mode-bg)', borderColor: 'transparent', position: 'sticky', top: 10, zIndex: 1000 } : {}}
        >
            {isSmallScreen && <NavMenuMobile />}
            <SearchBtn />
            <TrialAccount />
            <TranslateBtn />
            <DarkModeBtn />
            <ShortcutsBtn />
            <NotificationBtn />
            <UserBtn />
        </div>
    );
};



export default TopBar;
